<template>
    <div v-if="canAudit" :class="['month_form_audit_actions', `is-${mode}`]">
        <el-button
            v-for="item in actionList"
            :key="item.type"
            :type="mode==='button' ? item.buttonType : 'text'"
            :class="{[item.buttonType]:mode!=='button'}"
            :size="mode==='button' ? 'small' : 'medium'"
            @click="openConfirm(item)"
        >{{ item.label }}</el-button>
    </div>
</template>

<script>
    import api from '@/api/methods/index';

    export default {
        props: {
            formId: {
                type: [String, Number],
                default: ''
            },
            month: {
                type: String,
                default: ''
            },
            status: {
                type: [String, Number],
                default: ''
            },
            mode: {
                type: String,
                default: 'text'
            }
        },
        computed: {
            //有审批权限并且月报状态为待审批时显示审批按钮
            canAudit() {
                let power = this.$store.state.user.current_user?.shi_project_project_power?.power;
                return Number(power && power.month_approve) === 1 && Number(this.status) === -1;
            },
            //按钮列表
            actionList() {
                return [
                    {
                        type: 1,
                        label: '通过',
                        buttonType: 'primary',
                        successText: '月报通过成功'
                    },
                    {
                        type: 2,
                        label: '退回',
                        buttonType: 'danger',
                        successText: '月报退回成功'
                    }
                ];
            },
            formLabel() {
                if (!this.month) {
                    return '该月报';
                }
                return `${this.month.slice(0, 4)}年${this.month.slice(5, 7)}月月报`;
            }
        },
        methods: {
            openConfirm(config) {
                if (!this.formId) {
                    return;
                }
                this.$msgbox({
                    title: '提示',
                    message: `是否确认${config.label}${this.formLabel}？`,
                    closeOnClickModal: false,
                    showInput: true,
                    inputType: 'textarea',
                    inputValue: '',
                    inputPlaceholder: '请输入备注（选填）',
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    beforeClose: async (action, instance, done) => {
                        if (action !== 'confirm') {
                            done();
                            return;
                        }
                        instance.confirmButtonLoading = true;
                        try {
                            let param = {
                                form_id: this.formId,
                                type: config.type
                            };
                            let remark = instance.inputValue ? instance.inputValue.trim() : '';
                            if (remark) {
                                param.remark = remark;
                            }
                            let res = await api.project.passOrReturn(param);
                            if (res?.data?.state == 1) {
                                done();
                                this.$message({
                                    message: config.successText,
                                    type: 'success'
                                });
                                this.$emit('change', config.type);
                                return;
                            }
                            instance.confirmButtonLoading = false;
                        } catch (error) {
                            instance.confirmButtonLoading = false;
                        }
                    }
                }).catch(() => {

                });
            }
        }
    }
</script>

<style scoped lang="less">
.month_form_audit_actions {
    display: inline-flex;
    align-items: center;

    .el-button + .el-button {
        margin-left: 10px;
    }

    .primary {
        color: #67C23A;
    }

    .danger {
        color: #F56C6C;
        margin-right: 10px;
    }

    &.is-button {
        width: 100%;
        justify-content: center;
    }
}
</style>
